import api from 'api';

export const getPaymentLinkPlanPriceStatus = async (code: string) => {
  const response = await api().get(`payments/payment-link/${code}/plan/price`, {
    validateStatus: () => true,
  });

  return { status: response.status, data: response.data };
};
